import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import Button from '@mui/material/Button';
import Fullpage, {
  FullPageSections,
  FullpageNavigation,
  FullpageSection,
} from '@ap.cx/react-fullpage';
import homeBannerTop from '../assets/images/CIIE_CO.gif';
import styles from './LandingPage.module.css';
import logoWhite from '../assets/images/logo-white.png';
import logo from '../assets/images/logo.png';
import partnerLogos from '../content/LandingPageLogos.js';

function LandingPage() {
  const navigate = useNavigate();
  const toTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="fullpage-wrapper">
      <Fullpage>
        <FullPageSections>
          <FullpageSection>
            <div className="section">
              <div className={`container-fluid banner-top-con ${styles['min-height-100-vh']}`}>
                <div className={`container ${styles['fullpage-box']}`}>
                  <div className={styles.logo}>
                    <Link to="/">
                      <img
                        src={logo}
                        alt="logo"
                        height="100"
                      />
                    </Link>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                      <img
                        alt=""
                        src={homeBannerTop}
                      />
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                      <div className="banner-cap-right caption-block title-bg-text">
                        <h1>
                          <span>ACCELERATE YOUR</span> <br />
                          <span>STARTUP </span> <br />
                          <span>JOURNEY!</span>
                          <br />
                        </h1>
                        <p>Avail benefits upward of $500k from curated list of partners and CIIE.CO portfolio startups.</p>
                        <div className="btn-con xs-full-btn mt-1">
                          <span className="me-3">
                            <Link to="/login">
                              <Button
                                className="btn btn-red btn-xl"
                                variant="contained"
                              >
                                Startup Login
                              </Button>
                            </Link>
                          </span>
                          <span>
                            <Link to="/partner-application">
                              <Button
                                className="btn btn-red btn-xl btn-broder"
                                variant="contained"
                              >
                                Partner Application
                              </Button>
                            </Link>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FullpageSection>
          <FullpageSection>
            <div className={`section ${styles['bk-black']}`}>
              <div className="container-fluid">
                <div className={`container ${styles['fullpage-box']}`}>
                  <div className={styles.logo}>
                    <Link onClick={toTop}>
                      <img alt="logo" src={logoWhite} height="100" />
                    </Link>
                  </div>
                  <div className={`row ${styles['min-height-100-vh']}`}>
                    <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 align-self-center">
                      <div className="caption-block">
                        <h2>EXPLORE PARTNER OFFERINGS</h2>
                        <p>
                          We&apos;ve assembled a set of credits, deals, and offers designed to give CIIE.CO startups an added boost.
                        </p>
                      </div>
                    </div>
                    {partnerLogos.length > 0 && (
                      <div className={`col-sm-12 col-md-12 col-lg-8 col-lg-8 d-flex flex-wrap justify-content-center align-self-center ${styles['home-slider']}`}>
                        <Carousel>
                          {partnerLogos.map((slide, index) => (
                            <Carousel.Item key={index}>
                              <div className="row">
                                {slide.map((content, key) => (
                                  <div
                                    className="col-4 col-md-4"
                                    key={key}
                                  >
                                    <div className={`${styles['partner-logo-img-con']}`}>
                                      <a
                                        className={`${styles['partner-logo-img-box']}`}
                                        href=""
                                      >
                                        <img
                                          className="partner-logo-img"
                                          src={content.logo}
                                          alt="First slide"
                                        />
                                      </a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Carousel.Item>
                          ))}
                        </Carousel>
                        <Button className="btn btn-red btn-xl" onClick={() => navigate('/explore')}>Explore</Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </FullpageSection>
        </FullPageSections>
        <FullpageNavigation className="navigation" />
      </Fullpage>
    </div>
  );
}

export default LandingPage;
